<template>
    <div class="paybright pointer" @click="showModal">
        <span
            id="paybright-widget-container"
            :data-amount="amount"
            class="paybright-as-low-as pb-price"
        />
    </div>
</template>

<script>
const BUBBLING_PHASE = 3;

import { gtmTrack } from "@/util/gtm";

export default {
    name: "Paybright",
    props: {
        color: {
            type: String,
            default: "white"
        },
        price: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            amount: 0,
            clickedPhase: 0
        }
    },
    watch: {
        amount() {
            this.refresh();
        },
        price() {
            this.paybrightPrice();
        }
    },
    created() {
        this.paybrightPrice();
    },
    methods: {
        paybrightPrice() {
            this.amount = window.accounting.format(this.price, 2).toString().replace(/[,]/g, "");
        },
        refresh() {
            window.paybright.refresh();
        },
        showModal(e) {
            this.$el.querySelector(".paybright-learnmore").click();
            const isOriginalTrigger = e.target.className.includes("paybright-learnmore");
            this.clickedPhase = BUBBLING_PHASE == this.clickedPhase ? 0 : e.eventPhase;

            if (BUBBLING_PHASE == this.clickedPhase && isOriginalTrigger) {
                gtmTrack.financeInquires();
                this.$emit("click");
            }
        }
    }
}
</script>

<style lang="scss">
@import "~@s/_asset-mixers.scss";

.paybright {
    text-transform: initial;

    a {
        color: $orchid !important;
    }

    p {
        margin-bottom: 0;
    }

    img {
        display: inline;
    }
}
</style>
